import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import isClient from 'commons/isClient';
import { sendFBEvent, FB_EVENTS } from 'commons/fbEvents';
import useMetaFormattedCityStateZip from 'hooks/sendFBEventHooks/useMetaFormattedCityStateZip';
const useFBTradeSignup = () => {
  const $ = _c(5);
  const {
    formattedZip: zip,
    formattedCity: city,
    formattedState: state
  } = useMetaFormattedCityStateZip();
  let t0;
  let t1;
  if ($[0] !== city || $[1] !== state || $[2] !== zip) {
    t0 = () => {
      if (isClient()) {
        window.jbEventFBTradeSignup = () => {
          sendFBEvent(FB_EVENTS.LEAD, {
            content_name: "TradeSignup",
            zp: zip,
            ct: city,
            st: state
          });
        };
      }
    };
    t1 = [city, state, zip];
    $[0] = city;
    $[1] = state;
    $[2] = zip;
    $[3] = t0;
    $[4] = t1;
  } else {
    t0 = $[3];
    t1 = $[4];
  }
  useEffect(t0, t1);
};
export default useFBTradeSignup;